export const WyndhamCWKey = "8353";
export const WyndhamWBWKey = "8678";
export const WyndhamSEKey = "202263";
export const WyndhamSirKey = "204445";
export const getIsWyndham = (programKey) =>
  [WyndhamCWKey, WyndhamWBWKey, WyndhamSEKey, WyndhamSirKey].includes(programKey);
